import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { utils } from "@alife/cone-arms-core";
import { onFCP, onLCP } from "web-vitals";
import { initElementRenderObserver } from "./element-render-observe";
import { getNetworkSpeed, getResourceDomainInfo, setElementHighlight, compressPerformanceTimingData, observeDomTreeMutation } from "./utils";
import { PLUGIN_NAME, BIZ_LCP_ELEMENT_ID } from "./constant";
var getCommonInfo = utils.getCommonInfo, checkWin = utils.checkWin, watchPageVisibilityChange = utils.watchPageVisibilityChange, bindEvent = utils.bindEvent, getXPath = utils.getXPath, hookHashChange = utils.hookHashChange, hookHistory = utils.hookHistory, supportedEntryType = utils.supportedEntryType;
// 如果初始化插件时页面已经onload，直接获取performance并发送
// 如果初始化插件时页面还没有onload，则等页面onload时再获取performance并发送
var onLoad = function onLoad(callback) {
    var setTimeoutOnWindow = function setTimeoutOnWindow() {
        timer = setTimeout(callback);
    };
    var timer;
    if (document.readyState === "complete") {
        timer = setTimeout(callback);
    } else {
        window.addEventListener("load", setTimeoutOnWindow);
    }
    return function() {
        if (timer) {
            clearTimeout(timer);
        }
        window.removeEventListener("load", setTimeoutOnWindow);
    };
};
var Perf = /*#__PURE__*/ function() {
    "use strict";
    function Perf(core) {
        var _this = this;
        _class_call_check(this, Perf);
        // 字段
        _define_property(this, "hasSendPerf", void 0);
        _define_property(this, "lcpElement", void 0);
        _define_property(this, "core", void 0);
        _define_property(this, "uninstallHooks", void 0);
        _define_property(this, "sendReportTimer", void 0);
        _define_property(this, "commonInfo", void 0);
        _define_property(this, "resourceEntries", void 0);
        _define_property(this, "fcp", void 0);
        _define_property(this, "lcpMetric", void 0);
        _define_property(this, "navigationTiming", void 0);
        // 重要的 element 加载信息
        _define_property(this, "importantElementMetric", void 0);
        _define_property(this, "isPageHiddenInStart", void 0);
        // 自定义LCP节点开始渲染的时间
        _define_property(this, "bizLcpElementRenderTime", void 0);
        _define_property(this, "observerTiming", function() {
            var _window_performance, _window_performance1, _window;
            var fixTiming = function(originTiming, startTimeKey) {
                var originTimingObj = originTiming;
                if (originTiming && originTiming.toJSON) {
                    try {
                        originTimingObj = originTiming.toJSON();
                        delete originTimingObj.name;
                    } catch (e) {
                    // ignore
                    }
                }
                if (originTimingObj) {
                    var timing = {};
                    var startTime = isNaN(originTimingObj[startTimeKey]) ? 0 : originTimingObj[startTimeKey];
                    for(var key in originTimingObj){
                        if (isNaN(originTimingObj[key])) {
                            timing[key] = originTimingObj[key];
                        } else if (key !== startTimeKey && originTimingObj[key] >= startTime) {
                            timing[key] = Math.ceil(originTimingObj[key] - startTime);
                        } else {
                            timing[key] = Math.ceil(originTimingObj[key]);
                        }
                    }
                    return timing;
                }
                return originTimingObj;
            };
            if (supportedEntryType("navigation") && typeof ((_window_performance = window.performance) === null || _window_performance === void 0 ? void 0 : _window_performance.getEntriesByType) === "function") {
                if (performance.getEntriesByType("navigation").length > 0) {
                    var _performance_getEntriesByType = _sliced_to_array(performance.getEntriesByType("navigation"), 1), pageNav = _performance_getEntriesByType[0];
                    _this.navigationTiming = fixTiming(pageNav, "startTime");
                } else {
                    try {
                        new PerformanceObserver(function(entryList) {
                            var _entryList_getEntriesByType = _sliced_to_array(entryList.getEntriesByType("navigation"), 1), pageNav = _entryList_getEntriesByType[0];
                            _this.navigationTiming = fixTiming(pageNav, "startTime");
                        }).observe({
                            type: "navigation",
                            buffered: true
                        });
                    } catch (e) {
                        var _window_performance2, _window1;
                        if ((_window1 = window) === null || _window1 === void 0 ? void 0 : (_window_performance2 = _window1.performance) === null || _window_performance2 === void 0 ? void 0 : _window_performance2.timing) {
                            _this.navigationTiming = fixTiming(window.performance.timing, "navigationStart");
                        }
                    }
                }
            } else if ((_window = window) === null || _window === void 0 ? void 0 : (_window_performance1 = _window.performance) === null || _window_performance1 === void 0 ? void 0 : _window_performance1.timing) {
                _this.navigationTiming = fixTiming(window.performance.timing, "navigationStart");
            }
        });
        _define_property(this, "observerFCP", function() {
            var entryType = "paint";
            if (supportedEntryType(entryType)) {
                onFCP(function(fcpMetric) {
                    if (fcpMetric.value > 0) {
                        _this.fcp = Math.ceil(fcpMetric.value);
                    }
                });
            }
        });
        _define_property(this, "observerLCP", function() {
            var _window_performance;
            var entryType = "largest-contentful-paint";
            if (supportedEntryType(entryType)) {
                onLCP(function(lcpMetric) {
                    if (perfInstance.isInSamePage()) {
                        _this.lcpMetric = lcpMetric;
                    }
                }, {
                    reportAllChanges: true
                });
            } else if (!_this.bizLcpElementRenderTime && typeof ((_window_performance = window.performance) === null || _window_performance === void 0 ? void 0 : _window_performance.now) === "function") {
                if (document.getElementById(BIZ_LCP_ELEMENT_ID)) {
                    // 如果不支持LCP，但是页面中已有自定义LCP节点，直接获取当前耗时作为LCP
                    _this.bizLcpElementRenderTime = Math.ceil(performance.now());
                } else {
                    // 如果不支持LCP，尝试通过 MutationObserver 获取
                    observeDomTreeMutation(function() {
                        if (perfInstance.isInSamePage() && document.getElementById(BIZ_LCP_ELEMENT_ID)) {
                            _this.bizLcpElementRenderTime = Math.ceil(performance.now());
                            // 检测到自定义LCP节点渲染后，停止MutationObserver
                            return true;
                        } else if (performance.now() > 30000) {
                            // 如果30s后还没有检测到自定义LCP节点，停止MutationObserver
                            return true;
                        }
                        return false;
                    });
                }
            }
        });
        _define_property(this, "getConnection", function() {
            var _window_navigator, _window;
            var connectionData = {};
            // @ts-ignore get connection
            var connection = (_window = window) === null || _window === void 0 ? void 0 : (_window_navigator = _window.navigator) === null || _window_navigator === void 0 ? void 0 : _window_navigator.connection;
            if (typeof connection === "object" && connection) {
                // 网络连接类型 connection type,例：wifi, 3g,目前只在 chrome 中能拿到数据
                var net_type = connection.effectiveType || connection.type || "";
                // 网络带宽 connection bandwidth，单位 Mbps
                var downlink = connection.downlink || connection.downlinkMax || connection.bandwidth || "";
                connectionData = {
                    net_type: net_type,
                    downlink: downlink
                };
            }
            return connectionData;
        });
        _define_property(this, "sendTiming", function(customLcp) {
            var _this_lcpMetric;
            if (_this.hasSendPerf || !_this.navigationTiming) {
                return;
            }
            _this.hasSendPerf = true;
            var timing = _this.navigationTiming;
            // 定义一个变量，说明当前是否有真实的LCP数据
            var useRealLcp = !!(_this.lcpMetric && _this.lcpMetric.value > 0);
            var fakeLcp = _this.bizLcpElementRenderTime || Math.ceil(timing.loadEventEnd);
            var useCustomLcp = !!customLcp && customLcp > 0;
            var fcpValue = _this.fcp > 0 ? _this.fcp : Math.ceil(timing.domInteractive) || 0;
            var lcpValue;
            if (useCustomLcp) {
                lcpValue = customLcp;
                if (lcpValue < fcpValue) {
                    fcpValue = lcpValue;
                }
            } else if (useRealLcp) {
                lcpValue = Math.ceil(_this.lcpMetric.value);
            } else {
                lcpValue = fakeLcp;
            }
            var logItem = _object_spread({
                timing: compressPerformanceTimingData(timing),
                dnsTime: Math.ceil((timing.domainLookupEnd || 0) - (timing.domainLookupStart || 0)),
                ttfb: Math.ceil(timing.responseStart),
                domComplete: Math.ceil(timing.domComplete),
                totalTime: Math.ceil(timing.loadEventEnd),
                fcp: fcpValue,
                lcp: lcpValue
            }, _this.getConnection());
            logItem.extendInfo = {
                isPageHiddenInStart: _this.isPageHiddenInStart,
                useRealLcp: useCustomLcp ? false : useRealLcp,
                uniAppWebviewPreload: useCustomLcp
            };
            var resourceLoadData = _this.getResourceLoadOverview();
            if (resourceLoadData.resourceCount && resourceLoadData.resourceCount > 0) {
                logItem.extendInfo.resourceCount = resourceLoadData.resourceCount;
                delete resourceLoadData.resourceCount;
                Object.assign(logItem, resourceLoadData);
            }
            var serverExecTime = _this.getServerExecTime(timing);
            if (serverExecTime > 0) {
                logItem.serverExecTime = serverExecTime;
            }
            if (!useCustomLcp && Array.isArray((_this_lcpMetric = _this.lcpMetric) === null || _this_lcpMetric === void 0 ? void 0 : _this_lcpMetric.entries) && _this.lcpMetric.entries.length > 0) {
                var entry = _this.lcpMetric.entries[_this.lcpMetric.entries.length - 1];
                if (entry && entry.element) {
                    logItem.extendInfo.lcpElement = getXPath(entry.element, 5);
                }
            }
            // 强行修正因为页面作弊，导致采集到的lcp比fcp小的情况
            if (logItem.lcp && logItem.fcp && logItem.lcp < logItem.fcp) {
                logItem.lcp = Number(logItem.fcp) + Math.ceil(Math.random() * 200);
            }
            _this.extendResourceTimingData(logItem);
            _this.core.logPerformance(_object_spread({}, _this.commonInfo, logItem));
            setElementHighlight(logItem.extendInfo.lcpElement || "");
        });
        _define_property(this, "isInSamePage", function() {
            return _this.commonInfo.url === utils.getUrl(_this.core.getConfig());
        });
        this.hasSendPerf = false;
        this.core = core;
        this.lcpElement = null;
        this.uninstallHooks = [];
        this.commonInfo = {};
        this.sendReportTimer = null;
        this.resourceEntries = [];
        this.fcp = 0;
        this.bizLcpElementRenderTime = 0;
        this.navigationTiming = null;
        this.isPageHiddenInStart = document.hidden;
    }
    _create_class(Perf, [
        {
            key: "getResourceLoadOverview",
            value: function getResourceLoadOverview() {
                var ret = {};
                if (!supportedEntryType("resource")) {
                    return ret;
                }
                var useCacheCount = 0;
                var slowLoadResourceCount = 0;
                var resourceCount = 0;
                performance.getEntriesByType("resource").forEach(function(entry) {
                    var fileTypeMatch = function() {
                        var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
                        if (name && typeof name.endsWith === "function") {
                            return name.endsWith(".js") || name.endsWith(".css");
                        }
                        return false;
                    };
                    var isFromCache = function() {
                        // 浏览器标记是从缓存中加载的资源
                        // @link https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/deliveryType
                        if (entry.deliveryType === "cache") {
                            return true;
                        }
                        // 通过 transferSize 判断是否是从缓存中加载的资源，但是这个值并不是所有浏览器都支持，所以需要增加对duration的判断，只是一个参考值
                        if (entry.transferSize === 0 && entry.duration < 300) {
                            return true;
                        }
                        // 通过 duration 判断是否是从缓存中加载的资源，只是一个参考值
                        if (entry.duration < 50) {
                            return true;
                        }
                        return false;
                    };
                    if (fileTypeMatch(entry.name)) {
                        resourceCount++;
                        if (isFromCache()) {
                            useCacheCount++;
                        }
                        if (entry.duration > 1000) {
                            slowLoadResourceCount++;
                        }
                    }
                });
                if (resourceCount > 0) {
                    return {
                        slowLoadResourceCount: slowLoadResourceCount,
                        cacheUseRate: (useCacheCount / resourceCount).toFixed(4),
                        resourceCount: resourceCount
                    };
                }
                return ret;
            }
        },
        {
            key: "getServerExecTime",
            value: function getServerExecTime(timing) {
                if (timing && Array.isArray(timing.serverTiming)) {
                    var appTiming = timing.serverTiming.find(function(serverTimingEntry) {
                        return serverTimingEntry && serverTimingEntry.name === "app";
                    });
                    if (appTiming && appTiming.duration) {
                        return appTiming.duration;
                    }
                    return undefined;
                }
                return undefined;
            }
        },
        {
            /**
   * 当LCP值较大时，同时上报resourceTimingList辅助研发进行数据分析
   * @param logItem
   */ key: "extendResourceTimingData",
            value: function extendResourceTimingData(logItem) {
                var _this = this;
                if (logItem.lcp > 2000 && supportedEntryType("resource")) {
                    var resourceTimingList = performance.getEntriesByType("resource").filter(function(entry) {
                        var fileTypeMatch = function() {
                            var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
                            if (name && typeof name.endsWith === "function") {
                                return name.endsWith(".js") || name.endsWith(".css");
                            }
                            return false;
                        };
                        return fileTypeMatch(entry.name) || [
                            "xmlhttprequest",
                            "fetch"
                        ].indexOf(entry.initiatorType) > -1;
                    });
                    var originExtendInfo = typeof logItem.extendInfo === "object" && logItem.extendInfo ? logItem.extendInfo : {};
                    var extendInfo = _object_spread({}, originExtendInfo);
                    if (resourceTimingList.length > 0) {
                        var storeFields = [
                            "name",
                            "initiatorType",
                            "duration",
                            "startTime",
                            "requestStart",
                            "responseEnd",
                            "transferSize",
                            "encodedBodySize",
                            "decodedBodySize",
                            "domainLookupStart",
                            "domainLookupEnd"
                        ];
                        extendInfo.resourceTimingList = resourceTimingList.filter(function(item) {
                            if (_this.lcpMetric && _this.lcpMetric.value > 0) {
                                // 最多只保留LCP元素出现后1s以内的资源请求数据
                                return item.startTime < Number(_this.lcpMetric.value) + 1000;
                            }
                            return true;
                        }).map(function(timing) {
                            return compressPerformanceTimingData(timing, storeFields);
                        });
                    }
                    Object.assign(logItem, {
                        extendInfo: _object_spread({}, extendInfo, getNetworkSpeed(), getResourceDomainInfo())
                    });
                }
            }
        },
        {
            key: "initReport",
            value: function initReport() {
                var _this = this;
                var doReport = function() {
                    _this.sendTiming();
                    reset();
                };
                var unbindBeforeunload = bindEvent(window, "beforeunload", doReport);
                this.sendReportTimer = setTimeout(doReport, 30000);
                var routeType = this.core.config.spaRouteType;
                var unbindHashChange = routeType && routeType !== "history" ? hookHashChange(doReport) : function() {};
                var unbindHistoryChange = routeType && routeType !== "hash" ? hookHistory(doReport) : function() {};
                var reset = function() {
                    unbindBeforeunload();
                    unbindHashChange();
                    unbindHistoryChange();
                    _this.sendReportTimer && clearTimeout(_this.sendReportTimer);
                };
                watchPageVisibilityChange(doReport, true);
                return function() {
                    reset();
                };
            }
        },
        {
            key: "initUniAppWebviewPreloadReport",
            value: function initUniAppWebviewPreloadReport() {
                var _this = this;
                var win = window;
                if (!this.isInUniAppPreloadWebview()) {
                    return;
                }
                win.reportLcpForReusedWebview = function(lcpValue) {
                    if (lcpValue > 0) {
                        _this.sendTiming(lcpValue);
                        // 手动上报允许多次重复上报
                        _this.hasSendPerf = false;
                    }
                };
                return function() {
                    win.reportLcpForReusedWebview = null;
                };
            }
        },
        {
            key: "isInUniAppPreloadWebview",
            value: function isInUniAppPreloadWebview() {
                var win = window;
                return win && win._isUniAppHackingLcp;
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                this.uninstallHooks = [];
                this.uninstallHooks.push(onLoad(function() {
                    var _this_core_config;
                    _this.commonInfo = getCommonInfo(((_this_core_config = _this.core.config) === null || _this_core_config === void 0 ? void 0 : _this_core_config.ignoredQueries) || [], _this.core.config);
                    _this.observerTiming();
                    _this.observerFCP();
                    if (_this.isInUniAppPreloadWebview()) {
                        _this.uninstallHooks.push(_this.initUniAppWebviewPreloadReport());
                    } else {
                        _this.observerLCP();
                        _this.uninstallHooks.push(_this.initReport());
                    }
                }));
            }
        }
    ]);
    return Perf;
}();
var perfInstance;
var TraceWebPerformancePlugin = function(core, param) {
    var _param_singleton = param.singleton, singleton = _param_singleton === void 0 ? true : _param_singleton, _param_enhanceElementTimingObserve = param.enhanceElementTimingObserve, enhanceElementTimingObserve = _param_enhanceElementTimingObserve === void 0 ? false : _param_enhanceElementTimingObserve;
    if (!(core && checkWin() && typeof core.logPerformance === "function")) {
        return [];
    }
    // 性能上报需要单例，不重复上报
    if (singleton && perfInstance && perfInstance.uninstallHooks) {
        return perfInstance.uninstallHooks;
    }
    try {
        perfInstance = new Perf(core);
        perfInstance.init();
        perfInstance.uninstallHooks.push(initElementRenderObserver(core, enhanceElementTimingObserve));
        return perfInstance.uninstallHooks;
    } catch (e) {
        console.warn(e);
    }
    return [];
};
TraceWebPerformancePlugin.pluginName = PLUGIN_NAME;
// 用于判断是否已经上报过页面加载的性能数据
export var hasReportedPerformance = function() {
    var _perfInstance;
    return (_perfInstance = perfInstance) === null || _perfInstance === void 0 ? void 0 : _perfInstance.hasSendPerf;
};
export default TraceWebPerformancePlugin;

 //# sourceMappingURL=index.js.map